import { Box } from "@chakra-ui/react";
import "./App.css";
import MainContainer from "./components/MainContainer";


function App() {
  return (
    <Box className="App" >
     <MainContainer />
    </Box>
  );
}

export default App;
